/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaseComponent } from '../base.component';
import { ContentInjectionService } from '../../services/utilities/contentInjection.service';
import { UtilsService } from '../../services';

@Component({
    selector: 'app-dropdown-wrapper',
    template: `<div #contentWrapper>
        <ng-content></ng-content>
    </div>`,
})
export class DropdownWrapperComponent extends BaseComponent implements AfterViewInit {
    @ViewChild('contentWrapper')
    public contentWrapper: ElementRef;

    /**
     * Store the id of the dropdown in order to add conditional classes if necessary.
     */
    @Input() public id;

    constructor(
        private contentInjectionService: ContentInjectionService,
        private utilsService: UtilsService
    ) {
        super();
    }

    ngAfterViewInit() {
        this.addClickHandlerToHtmlContent();
    }

    /**
     * Add click handler to HTML content, so you can close the dropdown.
     * @private
     */
    private addClickHandlerToHtmlContent(): void {
        const nativeElement = this.utilsService.getObjectValue(this.contentWrapper, 'nativeElement');
        const contentButtons = nativeElement.querySelectorAll('.menu-item-wrapper, span, li');
        for (const button of contentButtons) {
            button.addEventListener('click', () => {
                this.contentInjectionService.closeEmitter.next(true);
            });
        }
    }
}
